import { Toaster as SonnerToaster } from "sonner";
import { useTheme } from "@/hooks/use-theme";

export function Toaster() {
    const { effectiveTheme } = useTheme();

    return (
        <SonnerToaster
            theme={effectiveTheme}
            position="bottom-right"
            offset={{ bottom: 64, right: 16 }}
            toastOptions={{
                unstyled: true,
            }}
        />
    );
}
